import React from 'react';
import { MAIN_MOCKUP_URL } from '../data/assets';
type ProductStackProps = {
  label?: string;
  className?: string;
};
const volumes = [{
  n: '01',
  title: 'No-Start & Hard-Start'
}, {
  n: '02',
  title: 'Running-Fault'
}, {
  n: '03',
  title: 'Fuel & Carburetor'
}, {
  n: '04',
  title: 'Ignition, Electrical & Safety'
}, {
  n: '05',
  title: 'Mechanical, Tune-Ups & Storage'
}, {
  n: '06',
  title: 'Paperwork, Estimates & Pickup'
}];

/**
 * Imagen de producto. Si hay mockup principal (data/assets.ts) se usa ese;
 * si no, una pila de los 6 tomos dibujada con la identidad del pack.
 */
export function ProductStack({
  label = '6 volumes · 161 Bench Cards',
  className = ''
}: ProductStackProps) {
  if (MAIN_MOCKUP_URL) {
    return <img src={MAIN_MOCKUP_URL} alt="The six Small Engine Diagnostic Pro volumes and five bonuses" className={`mx-auto h-auto w-full rounded-2xl shadow-stack ring-1 ring-black/10 ${className}`} data-id="element-288" data-mp="r3lmmhnf70vw" />;
  }
  return <div className={`relative mx-auto aspect-[5/3] w-full max-w-[520px] ${className}`} role="img" aria-label="The six Small Engine Diagnostic Pro volumes" data-id="element-289" data-mp="1j1sljquq106b">
      {volumes.map((vol, i) => <div key={vol.n} className="topo-light absolute flex aspect-[4/3] w-[46%] flex-col overflow-hidden rounded-lg border border-black/10 bg-paper shadow-stack" style={{
      left: `${2 + i * 10}%`,
      top: `${i * 5.5}%`,
      transform: `rotate(${-5 + i * 2}deg)`,
      zIndex: i + 1
    }} data-id="element-290" data-mp="19zt5p1vg024y" data-mpi={i}>
          <div className="flex items-center justify-between bg-ember px-2 py-1" data-id="element-291" data-mp="1sz71zqgn9oym">
            <span className="font-display text-[10px] uppercase tracking-wider text-pine sm:text-xs" data-id="element-292" data-mp="1sx41gchv8dfn">
              Volume {vol.n}
            </span>
            <span className="flex gap-0.5" aria-hidden="true" data-id="element-293" data-mp="2lgt50hg7jh8h">
              {['bg-patrol-mustard', 'bg-pine', 'bg-moss', 'bg-signal'].map(c => <span key={c} className={`h-1.5 w-1.5 rounded-full ${c}`} data-id="element-294" data-mp="2gn6qejqhh3a1" />)}
            </span>
          </div>
          <div className="flex flex-1 flex-col justify-between px-2 py-1.5" data-id="element-295" data-mp="34kwcj4wm6ps5">
            <span className="font-display text-[13px] uppercase leading-[1.02] text-pine sm:text-[17px]" data-id="element-296" data-mp="2qsy9nbthxq4f">
              {vol.title}
            </span>
            <span className="border-t border-pine/15 pt-1 text-[6px] font-bold uppercase tracking-[1.5px] text-pine-muted sm:text-[8px]" data-id="element-297" data-mp="2ut8q5iewzyxj">
              Small Engine Diagnostic Pro
            </span>
          </div>
        </div>)}
      <span className="absolute bottom-0 left-1/2 z-20 -translate-x-1/2 whitespace-nowrap rounded-full bg-ember px-4 py-2 text-[12px] font-bold uppercase tracking-wide text-pine shadow-card" data-id="element-298" data-mp="2lrshpg7nu6vy">
        {label}
      </span>
    </div>;
}